import React from 'react';
import { Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, Button, CircularProgress, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';

const ShowReviewDialog = ({ open, onClose, reviewLoading, handleReview }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle sx={{ m: 0, p: 2 }}>
      Agregar reseña
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          padding:'2px',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers>
      <DialogContentText>
        ¿La recomendarías a un amigo?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button 
        onClick={() => handleReview(true)} 
        color="success" 
        disabled={reviewLoading} 
        startIcon={!reviewLoading && <ThumbUpIcon />}
      >
        {reviewLoading ? <CircularProgress size={24} /> : 'Sí'}
      </Button>
      <Button 
        onClick={() => handleReview(false)} 
        color="error" 
        disabled={reviewLoading} 
        startIcon={!reviewLoading && <ThumbDownIcon />}
      >
        {reviewLoading ? <CircularProgress size={24} /> : 'No'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ShowReviewDialog;
